/**
 * Turns whatever an admin typed in an activity's Location field into the island(s) the
 * filter offers, so "St Thomas, U.S. Virgin Islands", "St. Thomas" and "Charlotte Amalie,
 * St Thomas" all collapse into one "St Thomas" option in the Location dropdown.
 *
 * Nothing is hardcoded into the dropdown itself: an option only appears when at least one
 * activity on the page actually carries that location, and anything we do not recognise is
 * offered exactly as it was typed.
 */
const RULES = [
  { label: 'St John', test: /\bst\.?\s*-?\s*john\b/i },
  { label: 'St Thomas', test: /\bst\.?\s*-?\s*thomas\b/i },
  { label: 'St Croix', test: /\bst\.?\s*-?\s*croix\b/i },
  {
    label: 'British Virgin Islands',
    test: /\b(bvi|british virgin|tortola|virgin gorda|jost van dyke|anegada|the baths|norman island|cooper island|peter island|willy t)\b/i,
  },
  { label: 'Water Island', test: /\bwater island\b/i },
  { label: 'Lovango', test: /\blovango\b/i },
];

/** Island labels for one location string (falls back to the raw text). */
export const locationLabels = (location) => {
  const text = (location || '').trim();
  if (!text) return [];
  const matched = RULES.filter((rule) => rule.test.test(text)).map((rule) => rule.label);
  return matched.length ? matched : [text];
};

/** Every location option present in a list of activities, islands first then anything custom. */
export const locationOptionsFor = (activities) => {
  const seen = new Set();
  (activities || []).forEach((a) => locationLabels(a.location).forEach((label) => seen.add(label)));
  const known = RULES.map((rule) => rule.label).filter((label) => seen.has(label));
  const extras = [...seen].filter((label) => !known.includes(label)).sort((a, b) => a.localeCompare(b));
  return [...known, ...extras];
};

/** Does this activity belong to the picked location option? */
export const matchesLocation = (activity, option) => !option || locationLabels(activity.location).includes(option);

export default locationOptionsFor;
